function unwrap(response) {
  return response?.data ?? response;
}

export async function fetchPlanContent(client) {
  const response = await client.apiClient.rest.get('/v1/subscriptions/plan-content');
  return unwrap(response);
}

/** Raw REST preserves consent fields that the SDK checkout wrapper omits. */
export async function createSubscriptionCheckout(client, planId, term, metadata, options) {
  const consent = options.trialConsent;
  if (!consent || (options.startTrial === true && consent.decision !== 'accepted_trial')) {
    throw new Error('Review the subscription terms before continuing.');
  }
  const response = await client.apiClient.rest.post('/v1/iap/stripe/subscribe', {
    planId,
    term,
    ...metadata,
    ...(options.startTrial === true ? { startTrial: true } : {}),
    // Only an explicit, recorded paid choice suppresses a server-approved trial.
    ...(consent.decision === 'declined_trial' ? { skipTrial: true } : {}),
    trialConsent: consent
  });
  return unwrap(response);
}

export async function requestSubscriptionPlanChange(client, planId, term, metadata, billingConsent) {
  const response = await client.apiClient.rest.post('/v1/subscriptions/change-plan', {
    planId,
    term,
    ...metadata,
    billingConsent
  });
  return unwrap(response);
}

/** This endpoint charges the existing Stripe plan immediately. Never retry it
 * as a different paid purchase or use it after failed trial eligibility. */
export async function activateStripeTrialPaid(client, billingConsent) {
  if (billingConsent?.accepted !== true) throw new Error('Accept the paid subscription terms before continuing.');
  const response = await client.apiClient.rest.post('/v1/subscriptions/activate-paid', {
    confirmation: 'activate_paid_now', billingConsent
  });
  return unwrap(response);
}
